<template>
  <div class="main-layout">
    <div class="main-layout__container">
      <div class="main-layout__left">
        <LeftMenu></LeftMenu>
      </div>
      <router-view />
    </div>
    </div>
</template>

<script>
import LeftMenu from './LeftMenu.vue';
import ApplicationButton from './ApplicationButton.vue';
export default {
  components: {
    LeftMenu,
    ApplicationButton,
  },
  data() {
    return {
      collapse: false,
    };
  },
  computed: {},
  mounted() {
    const me = this;
    me.getDefaultValue()
  },
  watch: {},
  created() {
    let collapseCache = sessionStorage.getItem('menu-collapse');
    if (collapseCache) {
      this.collapse = JSON.parse(collapseCache);
    }
  },
  methods: {
    menuToogle() {
      this.collapse = !this.collapse;
      sessionStorage.setItem('menu-collapse', this.collapse);
    },
    /**
     * khởi tạo những dữ liệu 
     */
    async getDefaultValue() {
      const me = this;
        let role = me.$store.dispatch(
          `globalcontext/getRoles`
        );
         let nations = me.$store.dispatch(
          `globalcontext/getNations`
        );
         let nationsEmployee = me.$store.dispatch(
          `globalcontext/getNationsEmployee`
        );
         let partner = me.$store.dispatch(
          `globalcontext/getAllPartners`
        );
        await Promise.all([role,nations,nationsEmployee,partner]);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/layouts/mainLayout.scss';
</style>
